const AlbumItem = ({ homePath, albumCode, fileName, size }) => {
    const handleDragStart = (e) => {
        e.dataTransfer.setData('text/uri-list', e.target.src);
        e.dataTransfer.setData('text/plain', e.target.src);
        e.dataTransfer.setData('text/id', e.target.id);
        e.dataTransfer.setData('text/title', e.target.title);
        e.dataTransfer.setData('text/alt', e.target.alt);
    };

    if (!size) {
        size = 'max-w-64 max-h-64'
    }

    return (
        <img
            id={fileName}
            name={fileName}
            className={`flex rounded-lg aspect-auto object-fit mx-4 my-2 ${size}`}
            src={`/${homePath}/${albumCode}/${fileName}`}
            draggable="true"
            onDragStart={handleDragStart}
        />
    );
};

export default AlbumItem;

